import { render, staticRenderFns } from "./HighlightedArticle.vue?vue&type=template&id=75ea6550"
import script from "./HighlightedArticle.vue?vue&type=script&lang=js"
export * from "./HighlightedArticle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports